export enum ApiServicePaths {
  Ipfs = '/integrations/ipfs-svc',
  ProofVerificationRelayer = '/integrations/proof-verification-relayer',
  Auth = '/integrations/web3-auth-svc',
  QrLink = '/integrations/qr-link-manager-svc',
}
